import { createElement } from 'react';
import { createSvg } from './createSvg.js';
import '@vebox/etui-system';
import '@vebox/etui-system-elements';

const ParametersGlyph = /*#__PURE__*/createElement("g", {
  id: "parameters"
}, /*#__PURE__*/createElement("rect", {
  x: "18",
  y: "25",
  width: "6",
  height: "6"
}), /*#__PURE__*/createElement("rect", {
  x: "18",
  y: "39",
  width: "6",
  height: "6"
}), /*#__PURE__*/createElement("rect", {
  x: "18",
  y: "53",
  width: "6",
  height: "6"
}), /*#__PURE__*/createElement("path", {
  d: "M31.9,25h31.3c1.6,0,2.9,1.3,2.9,3s-1.3,3-2.9,3H31.9c-1.6,0-2.9-1.3-2.9-3S30.3,25,31.9,25z"
}), /*#__PURE__*/createElement("path", {
  d: "M31.9,39h31.3c1.6,0,2.9,1.3,2.9,3s-1.3,3-2.9,3H31.9c-1.6,0-2.9-1.3-2.9-3S30.3,39,31.9,39z"
}), /*#__PURE__*/createElement("path", {
  d: "M31.9,53h11.3c1.6,0,2.9,1.3,2.9,3s-1.3,3-2.9,3H31.9c-1.6,0-2.9-1.3-2.9-3S30.3,53,31.9,53z"
}));
const Parameters = createSvg({
  name: 'parameters',
  path: ParametersGlyph
});

export default Parameters;
export { ParametersGlyph };
